import resolveImage from './resolveImage';
import resolveRTC from './resolveRTC';

const resolveTabContent =
  (resolveContentBlocks: any) =>
  ({ rawVal = [], page, pageModels }: PropsWithCMSProps<TabContentProps>): TabContentType[] => {
    return rawVal.map((raw) => {
      const {
        tabDetailContent,
        tabDescription,
        tabContainerBackgroundImage,
        tabTitleCompound,
        featuredContent,
      } = raw;
      return {
        tabDetailContent: tabDetailContent
          ? {
              heading: resolveRTC({ rawVal: tabDetailContent.heading }),
              superHeading: tabDetailContent.superheading,
              detailContent: resolveContentBlocks({
                rawVal: tabDetailContent.detailContent,
                page,
                pageModels,
              }),
              mediaContent: resolveContentBlocks({
                rawVal: tabDetailContent.mediaContent,
                page,
                pageModels,
              }),
              // cta: resolveLink({ rawVal: tabDetailContent.cta, page, pageModels }),
            }
          : undefined,
        tabDescription: resolveRTC({ rawVal: tabDescription }),
        tabContainerBackgroundImage: resolveImage({ rawVal: tabContainerBackgroundImage, page }),
        tabTitle: tabTitleCompound
          ? {
              logo: resolveImage({ rawVal: tabTitleCompound.imagecompound, page }),
              thumbnail: resolveImage({ rawVal: tabTitleCompound.thumbnailTitle, page }),
              text: tabTitleCompound.textTitle,
            }
          : undefined,
        featuredContent,
      };
    });
  };

export default resolveTabContent;
